import { useMemo } from 'react';
import { useWidget } from '@telescope/cassini-hooks';
import { AuthNav, useAuth } from 'features';
import { VoteHeader } from './VoteHeader';
import { RoundNav } from './RoundNav';
import { BracketGrid } from './BracketGrid';
import { BracketGridProvider } from '../providers/BracketGridProvider';
import { ModalsProvider } from 'features';
import { getVoteOptionsList } from '../utils';
import { VoteGroupData } from 'types';
import { Open } from 'generated-types/widget';

export const BracketVoteApp = () => {
  const { user } = useAuth();
  const { data: voteSettings } = useWidget<Open>({
    select: (data) => data.snapshot.voting?.vote_settings?.ruleset_parameters,
  });
  const { vote_limit: voteLimit, hasDailyVoteLimit } = voteSettings;
  const { data } = useWidget<Open>({ select: (data) => data.widget });
  const { vote_groups: voteGroups, rounds, settings } = data.bracket.bracketView.bracket_vote;
  const { widget_vote_choices: widgetVoteChoices } = data.voteOptions.settings.contestants;
  const activeRound = rounds.filter((round: { is_active: boolean }) => round.is_active)[0].round_id;
  // Last round is WINNER round. Voting is disabled.
  const totalVotingRounds = rounds.length - 1;

  const voteOptions = useMemo(
    () => getVoteOptionsList(voteGroups as VoteGroupData[], widgetVoteChoices, totalVotingRounds),
    [voteGroups, totalVotingRounds, widgetVoteChoices]
  );

  return (
    <>
      <ModalsProvider>
        <BracketGridProvider
          {...{ activeRound, totalRounds: totalVotingRounds, voteOptions, voteLimit, hasDailyVoteLimit, user }}
          bracketType={settings.bracket_type}>
          <AuthNav />
          <VoteHeader />
          <RoundNav />
          <BracketGrid />
        </BracketGridProvider>
      </ModalsProvider>
    </>
  );
};
